import { useCallback } from "react";

export const useScrollToElement = () => {
  const scrollToElement = useCallback(
    (element: HTMLElement | null, options?: ScrollIntoViewOptions) => {
      if (!element) return;

      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        ...options,
      });
    },
    []
  );

  return { scrollToElement };
};
